import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { stories } from "@/data/stories";

const spans = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];
const heights = ["h-[420px] md:h-[520px]", "h-[420px] md:h-[520px]", "h-[360px] md:h-[460px]", "h-[360px] md:h-[460px]"];

export default function Gallery() {
  return (
    <section id="bajki" className="relative py-28 md:py-40" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="mb-14 md:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-8"
        >
          <div>
            <span className="chip" data-testid="gallery-eyebrow">
              <span className="dot" /> Kolekcja bajek
            </span>
            <h2 className="font-display font-semibold text-[#051937] text-4xl sm:text-5xl lg:text-6xl mt-6 tracking-tight leading-[1.02] max-w-2xl">
              Cztery historie, w których magia zaczyna się w kieszeni piżamy.
            </h2>
          </div>
          <p className="text-[#0b2a55]/75 text-lg max-w-sm">
            Kliknij bajkę, by przeczytać ją w całości — razem z bohaterami, którzy w niej grają.
          </p>
        </motion.div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {stories.map((s, i) => (
            <motion.article
              key={s.slug}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className={`col-span-12 ${spans[i]} group`}
              data-testid={`st-${s.number}`}
            >
              <Link
                to={`/bajka/${s.slug}`}
                data-testid={`story-link-${s.number}`}
                className="block"
              >
                <div className={`spotlight ${heights[i]} relative`}>
                  <motion.img
                    src={s.scene}
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover"
                    whileHover={{ scale: 1.06 }}
                    transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
                  />
                  <div className="absolute inset-0 z-10 p-6 md:p-10 flex flex-col justify-between text-white">
                    <div className="flex items-center justify-between">
                      <span className="chip !bg-white/85 !text-[#051937]">
                        <span className="dot" /> {s.tag}
                      </span>
                      <motion.div
                        whileHover={{ rotate: 45 }}
                        className="w-11 h-11 rounded-full bg-white/90 text-[#051937] grid place-items-center"
                      >
                        <ArrowUpRight size={20} />
                      </motion.div>
                    </div>
                    <div>
                      <h3 className="font-display font-semibold text-2xl md:text-4xl leading-tight tracking-tight max-w-xl drop-shadow-[0_4px_20px_rgba(0,0,0,0.45)]">
                        {s.title}
                      </h3>
                      <p className="mt-3 text-white/85 text-sm md:text-base max-w-md drop-shadow-[0_2px_10px_rgba(0,0,0,0.35)]">
                        {s.subtitle}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
